import { render, staticRenderFns } from "./DiscountViewPage.vue?vue&type=template&id=0b53cb0a&"
import script from "./DiscountViewPage.vue?vue&type=script&lang=js&"
export * from "./DiscountViewPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscountViewPage.vue?vue&type=style&index=0&id=0b53cb0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports